import React from 'react';
import ReactDOM from 'react-dom';
import Index from '../common/index';

const componentElm = typeof document !== 'undefined' && document.querySelector('.user_page_perseus');

if (componentElm) {
    const initialData = window.initialData.user_page_perseus;

    ReactDOM.render(
        <Index {...initialData}/>,
        componentElm
    );
}

if (module.hot) {
    module.hot.accept();
}

export default Index;



// WEBPACK FOOTER //
// ./src/client/index.js